module.exports = __webpack_public_path__ + "static/media/ahmed.d041eabe.jpg";